module.exports = ".ecg-btn.s3 {\n  height: 40px;\n  line-height: 40px; }\n"